import { useMemo } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { CrudStore } from 'src/core/types/crudStore'
import { createCrud } from 'src/core/types/helpers/createCrud'

interface IUseCrud {
  data: any
  key: string
  instanceId?: string
}

export const useCrud = <T = IForm>({ data, key, instanceId }: IUseCrud) => {
  return useMemo(() => {
    if (!CrudStore.has(key, instanceId)) {
      createCrud<T>(data[key])
    }

    return CrudStore.get<T>(key, instanceId)
  }, [data, instanceId, key])
}
